import React, {useMemo, useState} from "react"
import useRescuers from "hooks/useRescuers"
import useShifts from "hooks/useShifts"
import Rescuer from "components/Rescuer"
import RescuerSelect from "components/rescuer/RescuerSelect"
import Forward from "./Forward"
import {isEmpty} from "lodash"
import "./Section.09.Rescuers.css"


const RemoveIcon = () => <i className="fa-solid fa-xmark" aria-hidden="true"/>
const AddIcon = () => <i className="fa-solid fa-plus" aria-hidden="true"/>
const DoneIcon = () => <i className="fa-solid fa-check" aria-hidden="true"/>
const ForwardIcon = () => <i className="fa-solid fa-right-left" aria-hidden="true"/>


export default function RescuersSection(params) {

    const {rescue} = params
    const rescuers = useRescuers()
    const shifts = useShifts()
    const [forward, setForward] = useState({show: false})
    const canForward = rescue.permissions.forward
    const canSave = rescue.permissions.save

    const shift = useMemo(() => {
        return shifts.get(rescue.rescue.area)
    }, [shifts, rescue.rescue.area])

    // Someone to hand the list to: a participant, or anyone on the shift who isn't the lead already
    const hasForwardTarget = !isEmpty(rescue.rescue.rescuers)
        || shifts.getRescuers(rescue.rescue.area).some(rescuer => !rescue.containsRescuer(rescuer))


    const openForward = (rescuer) => {
        setForward({show: true, username: rescuer?.username})
    }

    const closeForward = () => {
        setForward({show: false})
    }

    const participantActions = (rescuer) => {
        if (!canForward && !canSave) return null
        return <>
            {canForward && <button className="rescuer-action" title="Postavi za vođu akcije" aria-label="Postavi za vođu akcije" onClick={() => openForward(rescuer)}><ForwardIcon/></button>}
            {canSave && <button className="rescuer-action remove" title="Izbaci iz liste" aria-label="Izbaci iz liste" onClick={() => rescue.removeRescuer(rescuer)}><RemoveIcon/></button>}
        </>
    }

    const shiftActions = (rescuer) => {
        if (rescue.containsRescuer(rescuer))
            return <span className="rescuer-action done" title="Već je u listi"><DoneIcon/></span>
        return <button className="rescuer-action add" title="Dodaj u listu" aria-label="Dodaj u listu" onClick={() => rescue.addRescuer(rescuer)}><AddIcon/></button>
    }

    return <li className="accordion" id="accordion-rescuers">
        <input type="checkbox" className="accordion" name="accordion" id="acc-rescuers"/>
        <label className="accordion" htmlFor="acc-rescuers">Učesnici</label>
        <section className="accordion">
            <Forward show={forward.show} selected={forward.username} rescue={rescue} close={closeForward}/>

            <div className="field full">
                <h3>
                    <div>Vođa akcije</div>
                </h3>
                <div className="rescuers-lead">
                    <Rescuer rescuer={rescuers.getUser(rescue.rescue.username)} onClick="profile"/>
                    {canForward && (hasForwardTarget
                        ? <button type="button" className="btn btn-outline-primary btn-sm" onClick={() => openForward()}>
                            <ForwardIcon/><span>Promeni vođu akcije</span>
                        </button>
                        : <div className="rescuers-hint">Da promeniš vođu akcije, prvo dodaj učesnika.</div>
                    )}
                </div>
            </div>

            <div className="field full">
                <h3>
                    <div>Ostali učesnici</div>
                </h3>
                {rescue.rescue.rescuers?.map(rescuer => <Rescuer rescuer={rescuer} key={rescuer.username} onClick="profile" actions={participantActions(rescuer)}/>)}
            </div>

            {canSave && !isEmpty(shift) && <div className="field full semi">
                <h3>
                    <div>Smena</div>
                </h3>
                {[shift.head, ...(shift.rescuers ?? [])].filter(Boolean).map(rescuer => <Rescuer rescuer={rescuer} key={rescuer.username} onClick="profile" actions={shiftActions(rescuer)}/>)}
            </div>}

            {canSave && <div className="field full semi">
                <h3>
                    <div>Pretraga spasilaca</div>
                    <div>Nađi spasioca i klikni na njega da ga dodaš u listu</div>
                </h3>
                <RescuerSelect onClick={rescue.addRescuer} placeholder="Ime, nadimak, broj..."/>
            </div>}
        </section>
    </li>
}
